import BlogSingleContainer from "../../../components/miscellaneous/blog/blogSingle";

const BlogSingle = () => {
  return <BlogSingleContainer />;
};

export default BlogSingle;
